module.exports = __webpack_public_path__ + "img/dealer-icon-2.32770b57.png";